import type {Option} from 'platform/components';

import {useState} from 'react';

import {Nullish, useOnMount} from 'shared/web';

import {useHttpCalls} from '../../../../../api/useHttpCalls';

const filterEmptyOptions = (options: Option[]): Option[] =>
  options.filter((option) => option.value.trim() !== '');

export function useSmartSearchHistory() {
  const http = useHttpCalls();

  const [searchOptions, setSearchOptions] = useState<Option[] | Nullish>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const fetchHistory = () => {
    http.getSmartSearch().then((response) => {
      if (response) {
        setSearchOptions(filterEmptyOptions(response));
      }
    });
  };

  useOnMount(fetchHistory);

  const openMenu = () => {
    setMenuOpen(true);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const refetch = () => {
    fetchHistory();
  };

  return {searchOptions, menuOpen, openMenu, closeMenu, refetch};
}
